import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
}

export default function OverageMemberChangePlanModal({ closeModal }: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        closeModal('overageMemberChangePlan');
    }

    return (
        <Modal id="overageMemberChangePlanModal">
            <Modal.Header id="overageMemberChangePlanModalHeader" titleId="customGrouping.customGrouping" onHide={onClose} />
            <Modal.Body id="overageMemberChangePlanModalBody">
                <p>
                    <FormattedMessage id="customGrouping.error.overageMembersGroupOnly" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="overageMemberChangePlanModalCloseButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.close" 
                />
            </Modal.Controls>
        </Modal>
    );
}
